import React, { Component } from 'react';

class Prompt extends Component {
  constructor(props) {
    super(props);

    const { onSubmit, message } = props;
    this.prompt = prompt(message);

    onSubmit(this.prompt);
  }

  componentWillUnmount() {
    this.prompt = null;
  }

  render() {
    return null;
  }
}

export default Prompt;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/Prompt/Prompt.js